<template>
  <div>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
          <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
          <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-card class="box">
          <v-toolbar dense class="toolbar" flat color="white">
              <v-toolbar-title>Offline Outstanding Fee Payment</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
          </v-toolbar>

          <v-row justify="center">
              <v-col cols="12" sm="4" md="4">
                  <v-combobox v-model="ay" rounded :items="ay_list" label="Select Academic Year" item-text="academicyear" outlined dense @click="show = false"></v-combobox>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                  <v-combobox v-model="registration_no" rounded :items="stud_list" label="Select Student" item-text="name" outlined dense prepend-icon="mdi-account-child-circle" @click="show = false"></v-combobox>
              </v-col>
              <v-btn class="button mt-3" v-if="registration_no != null && ay!=null" @click="show = true">Proceed</v-btn>
          </v-row>
          <!-- <v-toolbar v-if="student_receipts.length > 0" flat dense class="toolbar" align="center" justify="center">
              <v-toolbar-title>Previous Outstanding Fees Receipts</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
              </v-toolbar><br>
               <v-data-table :headers="headers1" :items="student_receipts" :search="search" class="elevation-1 mytable" dense v-if="student_receipts.length > 0">
               <template v-slot:item.print="{ item }">
                  <v-tooltip top color="warning">
                      <template v-slot:activator="{ on, attrs }">
                          <v-btn class="mt-1 mb-1" outlined rounded small color="warning" v-bind="attrs" v-on="on" @click="print(item.receipt_no,item.ay)"> <v-icon color="warning">mdi-printer</v-icon>Print Receipt</v-btn>
                      </template>
                      <span>
                          Print Fee Receipt!!!
                      </span>
                  </v-tooltip>
              </template>
               </v-data-table>
               <span v-if="student_outstanding_fees_list.length > 0 || student_outstanding_fees_list == '' || student_outstanding_fees_list =='' " >
               </span>
          <v-toolbar v-if="student_outstanding_fees_list.length > 0" flat dense class="toolbar" align="center" justify="center">
              <v-toolbar-title>Student Oustanding Fees Details</v-toolbar-title>
                      <v-divider class="mx-4" inset vertical></v-divider>
                  </v-toolbar><br>
          <v-data-table :headers="headers" :items="student_outstanding_fees_list" :search="search" class="elevation-1 mytable" dense v-if="student_outstanding_fees_list.length > 0">
              <template v-slot:item.select_payment_mode="{ item }">
                  <div v-if="item.balance > 0">
                      <v-autocomplete v class="mb-none pb-none mt-4" color="#0F2027" dense rounded required v-model="item.select_mode" :items="payment_modes" item-text="payment_mode_name" item-value="paymentmode_id" label="Payment Mode" outlined />
                  </div>
                    <div v-else class="text">
                  <strong>Already Paid</strong>
                  </div>
              </template>
              <template v-slot:item.pay_fee="{ item }">
                  <div v-if="item.balance > 0">
                      <v-text-field class="mt-none pt-none" rounded label="Enter Amount" hide-details="auto" v-model="item.pay_fee" outlined dense></v-text-field>
                  </div>
                    <div v-else class="text">
                 <strong>Already Paid</strong>
                  </div>
              </template>
              <template v-slot:item.pay_button="{ item }">
                  <div v-if="item.balance > 0">
                      <v-btn  outlined rounded class="button" small @click="payfees(item)">Pay Now</v-btn>
                  </div>
                  <div v-else class="text">
                  <strong>Already Paid</strong>
                  </div>
              </template>
          </v-data-table> -->

          <student-offline-outstanding v-if="show == true" :registration_no="registration_no" :ay="ay.ay_id"></student-offline-outstanding>
      </v-card>
      <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
  </div>
</template>
<script>
  import "@/assets/css/color.css"; // css needs to be imported for each dashboard
  import StudentOfflineOutstanding from "./StudentOfflineOutstanding";
  import axios from "axios";
  export default {
      name: "StudentOfflineOutstanding",
      components: {
          "student-offline-outstanding": StudentOfflineOutstanding,
      },
      data: () => ({
          show: false,
          registration_no: "",
          stud_list: [],
          snackbar_msg: "",
          color: "",
          snackbar: false,
          overlay: false,
          current_ay: "",
          search: "",
          s3url: "",
          headers: [
              { text: "Sr. No.", value: "srno" },
              { text: "PRN No.", value: "stud_reg_no", align: "center" },
              { text: "Academic Year", value: "of_academicyear" },
              { text: "Fees", value: "fee" },
              { text: "Paid Fees", value: "paid_fee" },
              { text: "Balance", value: "balance" },
              { text: "Payment Mode", value: "select_payment_mode" },
              { text: "Amount", value: "pay_fee" },
              { text: "Pay", value: "pay_button", align: "center" },
          ],
          headers1: [
              { text: "Sr. No.", value: "srno" },
              { text: "PRN No.", value: "registration_number" },
              { text: "Name", value: "name" },
              { text: "For Academic Year", value: "of_ay" },
              { text: "Standard", value: "standard" },
              { text: "Quota", value: "quota" },
              { text: "Stream", value: "stream" },
              { text: "Receipt No", value: "receipt_no" },
              { text: "Receipt Date", value: "receipt_date" },
              { text: "Transaction Date", value: "trxn_date" },
              { text: "Amount", value: "amount" },
              { text: "Payment Mode", value: "payment_mode" },
              { text: "Print Receipt", value: "print", sortable: true },
          ],
          student_outstanding_fees_list: [],
          payment_modes: [],
          select_mode: "",
          new_input: "",
          student_receipts: [],
          ay_list:[],
          ay:null,
      }),
      methods: {
          print(receipt_no, ay) {
              this.receipt_no = receipt_no;
              this.$session.set("receipt_no", JSON.stringify(receipt_no));
              this.$session.set("ay", JSON.stringify(ay));
              this.$session.set("registration_no", JSON.stringify(this.registration_no.registration_number));
              this.$router.push({
                  name: "student-outstanding-payment-receipt",
              });
          },
          payfees(item) {
              if (item.pay_fee == null || item.pay_fee == "") {
                  this.showSnackbar("#b71c1c", "Please enter fees amount!");
                  return;
              } else if (item.select_mode == null || item.select_mode == "") {
                  this.showSnackbar("#b71c1c", "Please select Payment Mode!");
                  return;
              } else {
                  const data = {
                      fees_amount: item.pay_fee,
                      payment_mode: item.select_mode,
                      outstanding_fee_id: item.outstanding_fee_id,
                      learner_reg_no: this.registration_no.registration_number,
                  };
                  this.overlay = true;
                  axios
                      .post("OutstandingFees/save_offline_outstanding_fees", data)
                      .then((res) => {
                          this.overlay = false;
                          if (res.data.flag == "YES") {
                              //move to fees receipt
                              this.showSnackbar("#4CAF50", "Payment Done Successfully..");
                              this.getDetails();
                              this.select_mode = "";
                          }
                          if (res.data.flag == "NO") {
                              this.showSnackbar("#b71c1c", res.data.snackbar);
                              return;
                          }
                      })
                      .catch((error) => {
                          this.overlay = false;
                          window.console.log(error);
                          this.showSnackbar("#b71c1c", "Something Went Wrong");
                      })
                      .finally(() => {
                          this.overlay = false;
                      });
              }
          },
          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },
          getDetails() {
              if (this.registration_no == "") {
                  this.showSnackbar("#b71c1c", "Please Enter Registration No.");
                  this.student_outstanding_fees_list = [];
                  return;
              }
              const formData = {
                  registration_no: this.registration_no.registration_number,
              };
              this.overlay = true;
              axios
                  .post("OutstandingFees/getLearnerData", formData)
                  .then((res) => {
                      this.overlay = false;
                      if (res.data.flag == "YES") {
                          this.student_outstanding_fees_list = res.data.array_of_sof;
                          this.payment_modes = res.data.payment_modes;
                          this.student_receipts = res.data.student_receipts;
                      }
                      if (res.data.flag == "NO") {
                          this.showSnackbar("#b71c1c", res.data.snackbar);
                          return;
                      }
                  })
                  .catch((error) => {
                      this.overlay = false;
                      window.console.log(error);
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                  })
                  .finally(() => {
                      this.overlay = false;
                  });
          },
      },

      mounted() {
          axios
              .post("/FeesStructureInstallment/getdata")
              .then((res) => {
                  if (res.data.msg == "200") {
                      this.stud_list = res.data.stud_list;
                      this.ay_list = res.data.ay_list
                  } else {
                      alert("Somthing went wrong!!!");
                  }
              })
              .catch((error) => {
                  alert("Somthing went wrong!!!");
              })
              .finally(() => {
                  this.comp_load = false;
              });
      },
  };
</script>
<style scoped>
  .text {
      color: red !important;
  }
  .radiospace {
      margin: 1rem !important;
      padding: 0%;
  }
  .btn-css {
      outline: 0 !important;
      outline-offset: 0 !important;
      background-image: none !important;
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
      background-color: #fff !important;
      text-decoration: underline;
      color: #0f2027 !important;
      text-align: left;
  }

  .btn-css:hover {
      outline: 0 !important;
      outline-offset: 0 !important;
      background-image: none !important;
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
      background-color: #ffff !important;
      color: #0f2027 !important;
      text-decoration: underline;
      text-align: left;
  }
  .t-row {
      padding: 1rem i !important;
  }
  .mytable2 /deep/ thead th {
      background: #0f2027 !important; /* fallback for old browsers */
      background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
      background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
      background-color: #0f2027 !important;
      color: white !important;
      font-weight: bold !important;
      white-space: nowrap !important;
      text-align: center;
  }
  .delete-avatar {
      transition: 0.3s;
      border: 1px solid red;
      margin: 0.2rem !important;
  }
  .delete-avatar:hover {
      background-color: transparent;
  }
  .delete-v-icon {
      padding-left: 8px;
      padding-top: 1px;
      font-size: 15px;
  }
  .delete-v-icon:hover {
      color: white;
  }
  .v-dialogss {
      bottom: 880;
      right: 0;
  }
</style>
